import { render, staticRenderFns } from "./staff-input.vue?vue&type=template&id=1d59d970&scoped=true"
import script from "./staff-input.vue?vue&type=script&lang=js"
export * from "./staff-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d59d970",
  null
  
)

export default component.exports